import React from 'react'
import vtexlogo from '../../images/vtex-logo.svg'
import titamedialogo from '../../images/titamedia-logo.svg'

export const Footer = () => {
    return (
        <div className='main-footer'>
            <label className='main-footer__first-label'>
                Industrias Haceb S.A. - NIT: 890900281-4 - Línea Nacional gratuita 018000511000 – desde celular al #466  Correo: asesor.servicio@haceb.com - Dirección: Calle 59 No. 55 – 80 Copacabana, AntioquiaTodos los derechos reservados Haceb
            </label>
            <div className='main-footer__container'>
                <label className='main-footer__second-label'>
                    Desarrollado por <b>Centraal</b>
                </label>
            </div>
        </div>
    )
}
